<template>
	<div class="pc-user-page-skeleton" aria-hidden="true" aria-busy="true">
		<aside class="pc-user-page-skeleton__sidebar">
			<div class="pc-user-page-skeleton__profile">
				<span class="pc-user-page-skeleton__avatar"></span>
				<div class="pc-user-page-skeleton__profile-text">
					<span class="pc-user-page-skeleton__line pc-user-page-skeleton__line--name"></span>
					<span class="pc-user-page-skeleton__line pc-user-page-skeleton__line--greeting"></span>
				</div>
			</div>

			<div class="pc-user-page-skeleton__wallet">
				<span class="pc-user-page-skeleton__line pc-user-page-skeleton__line--wallet-title"></span>
				<span
					class="pc-user-page-skeleton__line pc-user-page-skeleton__line--wallet-balance"
				></span>
			</div>

			<div class="pc-user-page-skeleton__menu">
				<span v-for="item in 8" :key="item" class="pc-user-page-skeleton__menu-item"></span>
			</div>

			<div class="pc-user-page-skeleton__help">
				<span class="pc-user-page-skeleton__help-btn"></span>
				<span class="pc-user-page-skeleton__help-btn"></span>
				<span class="pc-user-page-skeleton__help-btn"></span>
			</div>
		</aside>

		<main class="pc-user-page-skeleton__main">
			<div class="pc-user-page-skeleton__main-header">
				<span class="pc-user-page-skeleton__line pc-user-page-skeleton__line--title"></span>
				<span class="pc-user-page-skeleton__line pc-user-page-skeleton__line--action"></span>
			</div>
			<div class="pc-user-page-skeleton__main-body">
				<div v-for="row in 4" :key="row" class="pc-user-page-skeleton__row">
					<div class="pc-user-page-skeleton__row-info">
						<span class="pc-user-page-skeleton__line pc-user-page-skeleton__line--row-title"></span>
						<span class="pc-user-page-skeleton__line pc-user-page-skeleton__line--row-meta"></span>
						<span
							class="pc-user-page-skeleton__line pc-user-page-skeleton__line--row-meta-short"
						></span>
					</div>
					<span class="pc-user-page-skeleton__row-action"></span>
				</div>
			</div>
		</main>
	</div>
</template>

<style lang="scss" scoped>
.pc-user-page-skeleton {
	display: flex;
	align-items: stretch;
	gap: 24px;
	width: 100%;
	min-height: 720px;
}

.pc-user-page-skeleton__sidebar,
.pc-user-page-skeleton__main {
	box-sizing: border-box;
	background: #ffffff;
	border-radius: 20px;
	box-shadow: 0 4px 24.6px rgba(0, 0, 0, 0.1);
	padding: 24px;
	min-height: 720px;
}

.pc-user-page-skeleton__sidebar {
	width: 286px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
}

.pc-user-page-skeleton__main {
	flex: 1;
	min-width: 0;
}

.pc-user-page-skeleton__profile {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 24px;
}

.pc-user-page-skeleton__profile-text {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.pc-user-page-skeleton__wallet {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 16px;
	margin-bottom: 24px;
	border-radius: 12px;
	background: #fafafa;
}

.pc-user-page-skeleton__menu {
	display: flex;
	flex-direction: column;
	gap: 12px;
	flex: 1;
}

.pc-user-page-skeleton__help {
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 24px;
}

.pc-user-page-skeleton__main-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 24px;
}

.pc-user-page-skeleton__main-body {
	display: flex;
	flex-direction: column;
}

.pc-user-page-skeleton__row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 108px;
	padding: 24px 0;
	border-bottom: 1px solid #efefef;
}

.pc-user-page-skeleton__row-info {
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 278px;
}

.pc-user-page-skeleton__avatar,
.pc-user-page-skeleton__line,
.pc-user-page-skeleton__menu-item,
.pc-user-page-skeleton__help-btn,
.pc-user-page-skeleton__row-action {
	display: block;
	background: linear-gradient(90deg, #f2f2f2 25%, #fafafa 40%, #f2f2f2 60%);
	background-size: 300% 100%;
	animation: pc-user-page-skeleton-shimmer 1.4s ease-in-out infinite;
}

.pc-user-page-skeleton__avatar {
	width: 56px;
	height: 56px;
	border-radius: 50%;
	flex-shrink: 0;
}

.pc-user-page-skeleton__line {
	height: 16px;
	border-radius: 4px;

	&--name {
		width: 120px;
		height: 22px;
		border-radius: 6px;
	}

	&--greeting {
		width: 88px;
		height: 14px;
	}

	&--wallet-title {
		width: 72px;
		height: 14px;
	}

	&--wallet-balance {
		width: 140px;
		height: 28px;
		border-radius: 6px;
	}

	&--title {
		width: 120px;
		height: 28px;
		border-radius: 6px;
	}

	&--action {
		width: 128px;
		height: 48px;
		border-radius: 10px;
	}

	&--row-title {
		width: 160px;
		height: 22px;
		border-radius: 6px;
	}

	&--row-meta {
		width: 200px;
	}

	&--row-meta-short {
		width: 140px;
	}
}

.pc-user-page-skeleton__menu-item {
	width: 100%;
	height: 42px;
	border-radius: 8px;
}

.pc-user-page-skeleton__help-btn {
	width: 100%;
	height: 40px;
	border-radius: 8px;
}

.pc-user-page-skeleton__row-action {
	width: 72px;
	height: 36px;
	border-radius: 8px;
	flex-shrink: 0;
}

@keyframes pc-user-page-skeleton-shimmer {
	0% {
		background-position: 100% 0;
	}
	100% {
		background-position: 0 0;
	}
}

@media (prefers-reduced-motion: reduce) {
	.pc-user-page-skeleton__avatar,
	.pc-user-page-skeleton__line,
	.pc-user-page-skeleton__menu-item,
	.pc-user-page-skeleton__help-btn,
	.pc-user-page-skeleton__row-action {
		animation: none;
	}
}
</style>
